import React, { useState } from 'react';
import styles from './login.module.scss';
import VerificationForm from './verification';

const InputLog = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [isFocused, setIsFocused] = useState(false); // State to track focus
  const [isFocusedPwd, setIsFocusedPwd] = useState(false);

  const [codeSubmit, setCodeSubmit] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();
    setCodeSubmit(true);
    // Handle login logic here
  };

  return (
    <div className={styles.box}>
      <div className={styles.imageContainer}>
        <img
          src={require('../../images/defatom.png')}
          className={styles.image}
          //className="errorImage img-fluid"
          alt="logo"
        />
      </div>

      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.text}>Let's get started</div>
        <div className={styles.inputGroup}>
          {/* <label htmlFor="email" style={styles.label}>Email:</label> */}
          <input
            type="email"
            placeholder="Email address"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ color: codeSubmit ? '#A9A9A9' : 'black' }}
            required
            className={styles.input}
            onFocus={() => setIsFocused(true)} // Set focus state to true
            onBlur={() => setIsFocused(false)} // Set focus state to false
            disabled={codeSubmit}
          />
          <img
            //src={require('../../icons/email.png')}
            src={require(`../../icons/${isFocused ? 'emailRed.png' : 'email.png'}`)}
            alt="email"
            className={styles.img1}
          />
        </div>
        <div className={styles.inputGroup}>
          {/* <label htmlFor="password" style={styles.label}>Password:</label> */}
          <input
            placeholder="Password"
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ color: codeSubmit ? '#A9A9A9' : 'black' }}
            required
            className={styles.input}
            onFocus={() => setIsFocusedPwd(true)} // Set focus state to true
            onBlur={() => setIsFocusedPwd(false)}
            disabled={codeSubmit}
          />
          <img
            //src={require('../../icons/password.png')}
            src={require(`../../icons/${isFocusedPwd ? 'passwdRed.png' : 'password.png'}`)}
            alt="email"
            className={styles.img1}
          />
        </div>
        <div className={styles.textPwd}>
          <a href="#">Forgot Password?</a>
        </div>
        {!codeSubmit && (
          <button type="submit" className={styles.button}>
            Send Code
          </button>
        )}
        {codeSubmit && <VerificationForm email={email} />}
      </form>
    </div>
  );
};
export default InputLog;
